import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { EdisonWallBoxFormData } from 'src/Libs/installation-statement/models/edisonWallBox'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import LabeledFieldDisplay from 'src/Libs/installation-statement/components/Overview/LabeledFieldDisplay'

const Edison: React.VFC<{ data: EdisonWallBoxFormData }> = ({ data }) => {
  const { t } = useCustomTranslation()

  return (
    <Stack spacing={2}>
      <Typography variant="h5">{t('installation-statement.edison.title')}</Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} display="flex" justifyContent={'space-between'}>
        <Box sx={{ minWidth: '40%' }}>
          <Box sx={{ pb: 2 }}>
            <Box sx={{ pb: 2 }}>
              <Typography variant="subtitle2">{t('installation-statement.edison.form.serial-number.title')}</Typography>
            </Box>
            <LabeledFieldDisplay label={t('installation-statement.edison.form.serial-numbers.connect')} dataField={data.serialNumbers.connect} />
            <LabeledFieldDisplay label={t('installation-statement.edison.form.serial-numbers.power')} dataField={data.serialNumbers.power} />
          </Box>
        </Box>
        <Box sx={{ minWidth: '40%' }}>
          <Box sx={{ pb: 2 }}>
            <Typography variant="subtitle2">{t('installation-statement.edison.form.vehicle-information.title')}</Typography>
          </Box>
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.vehicle-information.manufacturer')}
            dataField={data.vehicleInformation.manufacturer}
          />
          <LabeledFieldDisplay label={t('installation-statement.edison.form.vehicle-information.model')} dataField={data.vehicleInformation.model} />
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.vehicle-information.battery-capacity')}
            dataField={data.vehicleInformation.batteryCapacity}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.vehicle-information.software-version')}
            dataField={data.vehicleInformation.softwareVersion}
          />
        </Box>
      </Stack>

      <Box sx={{ pb: 2 }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="subtitle2">{t('installation-statement.edison.form.functionality-tests.title')}</Typography>
        </Box>
        <LabeledFieldDisplay
          label={t('installation-statement.edison.form.functionality-tests.fully-installed')}
          dataField={data.functionalityTests.fullyInstalled}
        />
        <LabeledFieldDisplay
          label={t('installation-statement.edison.form.functionality-tests.configured')}
          dataField={data.functionalityTests.configured}
        />
        <LabeledFieldDisplay
          label={`${t('installation-statement.edison.form.functionality-tests.scenario-one-tested.title')} ${t(
            'installation-statement.edison.form.functionality-tests.scenario-one-tested.body'
          )}`}
          dataField={data.functionalityTests.scenarioOneTested}
        />
        <LabeledFieldDisplay
          label={`${t('installation-statement.edison.form.functionality-tests.scenario-two-tested.title')} ${t(
            'installation-statement.edison.form.functionality-tests.scenario-two-tested.body'
          )}`}
          dataField={data.functionalityTests.scenarioTwoTested}
        />
        <LabeledFieldDisplay
          label={t('installation-statement.edison.form.functionality-tests.customer-briefed')}
          dataField={data.functionalityTests.customerBriefed}
        />

        <Typography variant="subtitle2">{t('installation-statement.edison.form.functionality-tests.bidirectional.title')}:</Typography>
        <Box sx={{ pl: 2 }}>
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.functionality-tests.bidirectional.positioned-at-charging-point')}
            dataField={data.functionalityTests.biDirectionalDCChargingConfiguration.positionedAtChargingPoint}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.functionality-tests.bidirectional.charging-location-defined')}
            dataField={data.functionalityTests.biDirectionalDCChargingConfiguration.chargingLocationDefined}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.edison.form.functionality-tests.bidirectional.function-activated')}
            dataField={data.functionalityTests.biDirectionalDCChargingConfiguration.functionActivated}
          />
        </Box>
      </Box>
    </Stack>
  )
}

export default Edison
